import { render, staticRenderFns } from "./MarketInsights.vue?vue&type=template&id=24ac8141&scoped=true&"
import script from "./MarketInsights.vue?vue&type=script&lang=js&"
export * from "./MarketInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ac8141",
  null
  
)

export default component.exports